// Strings for the read-only Caregivers tab, copied from client.ClientDetail.CaregiverConnections.
// Status is keyed by Loom's assignment status, plus the legacy REVIEW status.
export default {
  Title: 'Caregivers',
  Status: {
    REVIEW: 'Review',
    ACTIVE: 'Active',
    PENDING: 'Pending',
    INACTIVE: 'Inactive',
    REJECTED: 'Rejected',
  },
  Caregiver: {
    CaregiverName: 'Caregiver name',
  },
};
